import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {RoutingHelperService} from '../../services/routing-helper.service';

const fieldNames = ['id', 'urlPath', 'additionalOption'];

const routes: Routes = [
  {
    matcher: (url) => {
      const posParams = RoutingHelperService.CreatePosParams(fieldNames, url);
      return posParams ? {consumed: url, posParams} : null;
    },
    loadChildren: () => import('./modules/cpru2/cpru2.module').then((m) => m.Cpru2Module),
  },
  {
    path: ':urlPath',
    loadChildren: () => import('./modules/landing-page/landing-page.module').then((m) => m.LandingPageModule),
  },
  {
    path: '**',
    loadChildren: () => import('./modules/cpru2/cpru2.module').then((m) => m.Cpru2Module),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CareprovidersUnitRoutingModule {}
